import CheckboxGroup from './_checkbox-group';

export default CheckboxGroup;
